import Vue from 'vue'
import Calendar from 'v-calendar/lib/components/calendar.umd.js'
import DatePicker from 'v-calendar/lib/components/date-picker.umd.js'

Vue.use(Calendar, DatePicker);
